<template>
  <div class="mb-8">
    <h2 class="h3 border-b pb-2">{{ title }}</h2>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SettingsGroup",
  props: {
    title: String,
  },
};
</script>
